import { useState } from "react";
import "./ErrorModals.scss";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext";
import { useUser } from "contexts/userContext/userContext";
import Button from "components/Elements/Button/Button";
import { useToasts } from "react-toast-notifications";
import apiRequest from "utils/ApiRequest/apiRequest";
import LoadingImageElement from "../../../Elements/LoadingContainerElement/LoadingImageElement";

const DowngradeModal = ({ errorType }) => {
  const { getTextByKey, getHtmlByKey, getPath } = useContent();
  const { getUserData } = useUser();
  const { addToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);
  const modalObjects = {
    "min-storage": {
      title: "subscription-cannot-changed-title",
      text: "subscription-cannot-changed-storage-text",
      linkText: "free-space",
      linkUrl: "inbox",
    },
    "sub-users": {
      title: "subscription-cannot-changed-title",
      text: "subscription-cannot-changed-sub-users-text",
      linkText: "manage-sub-users",
      linkUrl: "user/profile/account",
    },
    "jumboforms-count": {
      title: "subscription-cannot-changed-title",
      text: "subscription-cannot-changed-jumboforms-count-text",
      linkText: "manage-jumboforms",
      linkUrl: "users/jumbo-forms/form-management",
    },
    "same-package": {
      title: "subscription-cannot-changed-title",
      text: "subscription-cannot-changed-same-package-text",
      linkText: "plans",
      linkUrl: "plans",
    },
    "auto-renewal": {
      title: "subscription-can-be-renewed-title",
      text: "subscription-can-be-renewed-text",
    },
    "paypal-downgrade": {
      title: "cannot-downgrade-paypal-title",
      text: "cannot-downgrade-paypal-text",
      linkText: "contact-us",
      linkUrl: "contact-us",
    },
  };

  const renewSubscription = async () => {
    setIsLoading(true);

    const body = {
      UserId: getUserData()?.UserId,
      Renew_Subscription: true,
    };

    const response = await apiRequest(
      "Users",
      "UserRenewBilling",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        // Navigate to profile page with parameter which will show success message
        window.location.href =
          window.location.origin +
          getPath() +
          "user/profile/account?renew-subscription-success=true";
      } else {
        addToast(getTextByKey("renew-subscription-failed"), {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } else {
      addToast(getTextByKey("renew-subscription-failed"), {
        appearance: "error",
        autoDismiss: true,
      });
    }

    setIsLoading(false);
  };

  return (
    <div className="downgrade-modal">
      <div className="title">{getTextByKey(modalObjects[errorType].title)}</div>
      <div className="text">{getHtmlByKey(modalObjects[errorType].text)}</div>
      <div className="actions">
        {errorType === "auto-renewal" ? (
          <Button onClick={renewSubscription} disabled={isLoading}>
            {isLoading ? <LoadingImageElement /> : null}
            {getTextByKey("enable-auto-renew")}
          </Button>
        ) : (
          <LinkToNewTab page={modalObjects[errorType].linkUrl} isNewTab={true}>
            <Button className="new-button">
              {getTextByKey(modalObjects[errorType].linkText)}
            </Button>
          </LinkToNewTab>
        )}
      </div>
    </div>
  );
};

export default DowngradeModal;
